<div>
  <div class="modal-header pb-0">
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <h4 class="h4 modal-title">
    <span i18n>Warning</span>
  </h4>
  <div class="modal-body px-5">
    <div *ngIf="deployedList">
      <div data-test="deployed-list-content">
        {{ deployedListMessage }}
      </div>
      <div class="mt-3">{{ deployedListConfirmation }}</div>
    </div>
    <div *ngIf="!deployedList" data-test="non-deployed-list-content">
      {{ nonDeployedListMessage }}
    </div>
  </div>
  <div class="modal-footer justify-content-center">
    <button
      type="button"
      class="btn-save btn overwrite-btn px-4"
      i18n
      (click)="modal.close()"
      *ngIf="!deployedList"
    >
      Overwrite
    </button>
    <button type="button" class="btn-save btn import-btn" i18n (click)="modal.close()" *ngIf="deployedList">
      Import
    </button>
    <button type="button" class="btn-save btn cancel-btn" i18n (click)="modal.dismiss()">Cancel</button>
  </div>
</div>
